<template>
    <div class="homeContainer">
        <spinner v-if="loading" size="200"/>
        <div v-else>
            <div class="firstLine">
                <div>
                    <h1 class="capitalize">Bonjour {{ firstname }} !</h1>
                    <div class="nextDelivery mt-6">
                        <div class="content-center">
                            <h3 class="mb-2">
                                Votre prochaine livraison est prévue le {{ nextDelivery.date | moment }}
                            </h3>
                        </div>
                        <router-link :to="{ name: 'commands' }">
                            <b-button class="mt-2">Gérer ma livraison</b-button>
                        </router-link>
                    </div>
                </div>
                <div class="b-corp-tagline">
                    <img src="/images/b-corp-tagline.png" alt="Entreprise certifiée B-Corp">
                </div>
            </div>
            <div class="flex homeCardContainer mt-4 pt-10">
                <HomeCard :data="novelty"/>
                <HomeCard :data="blog"/>
            </div>
            <router-link class="comm-link" :to="{name: 'communication'}">
                Retrouvez les communications du mois !
            </router-link>
        </div>
    </div>
</template>

<script>
import {apiCallRebuild, notifyErrorFetchRaw} from "@/helper";
import {API_ROUTES} from "@/Services/api.common.service";
import HomeCard from "@/views/Home/HomeCard";
import {mapState} from "vuex";

export default {
    computed: mapState({
        firstname: (state) => state.account.firstname,
    }),
    components: {
        HomeCard,
    },
    data() {
        return {
            novelty: {},
            blog: {},
            nextDelivery: {},
            account: {},
            loading: true,
        };
    },
    watch: {$route: "fetchData"},
    created() {
        this.fetchData();
    },

    methods: {
        async fetchData() {
            const notifyError = notifyErrorFetchRaw.bind(this);

            try {
                const apiRes = await apiCallRebuild(API_ROUTES.home);
                this.novelty = apiRes?.novelty?.animation || {};
                this.blog = apiRes?.blog?.animation || {};
                this.nextDelivery = apiRes?.nextDelivery?.nextDelivery || {};
                this.account = apiRes?.account?.account || {};

                window.jimo.push(['set', 'user:id', [this.account.id]]);
                window.jimo.push(['set', 'user:name', [`[${this.account.company}] ${this.account.firstname} ${this.account.lastname}`]]);
                window.jimo.push(['set', 'user:email', [this.account.email]]);

                window.FrontChat("init", {
                    chatId: "85f1acb3fea80111e0c9b09165be2eb3",
                    useDefaultLauncher: true,
                    email: this.account.email,
                    userHash: this.account.frontUserHash,
                });

                this.loading = false;
            } catch (e) {
                notifyError();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.firstLine {
    display: flex;
    justify-content: space-between;
    height: 100%;

    h1 {
        font-size: 3.5em;
        margin-bottom: 40px;
    }

    .b-corp-tagline {
        width: min(15vw, 150px);
    }
}

.nextDelivery {
    h3 {
        font-size: 1.3em;
    }

    button {
        font-size: 1em;
    }
}

.homeCardContainer {
    flex-direction: column;
    row-gap: 4em;
    margin-bottom: 4rem;
    padding-right: min(100px, 8vw);

    h2 {
        font-size: 2.2em;
        margin-top: 25px;
        margin-bottom: 10px;
    }
}

a.comm-link {
    font-family: Ultramagnetic, sans-serif;
    text-decoration: underline;
    font-size: 1.2em;
}
</style>
